module.exports = {
  en: {
    'HRES7FEC1': {
      '10': 'For Year',
      '20': 'Tr.Course',
      '30': 'Tr.Class no.',
      '40': 'From training dte.',
      '50': 'To',
      '60': 'TR.Course code',
      '70': 'TR.Course Name',
      '80': 'Class no.',
      '90': 'Type of Training',
      '100': 'Status',
      '110': 'Record Date'
    },
    'HRES7FEC2': {
      '10': 'for year',
      '20': 'Tr.Course',
      '30': 'Class no.',
      '40': 'Evaluation form',
      '50': 'Other',
      '60': 'Join training by',
      '70': 'Get press releases from the media',
      '80': 'have knowledge before and after training. How much',
      '90': 'Score before training',
      '100': 'Scores after training',
      '110': 'Evaluation form',
      '120': 'Evaluation result',
      '130': 'Suggestion',
      '140': 'Knowledge from training.',
      '150': 'Benefits of Training',
      '160': 'Comments / suggestions',
      '170': 'Weight',
      '180': 'Score',
      '190': 'Evaluation status',
      '200': 'During of evaluation',
      '210': 'Finish of evaluation'
    },
    'INFORMTBY': {
      '101': 'Newsletter',
      '102': 'E-mail',
      '103': 'Public Relations Forum',
      '104': 'New employees'
    },
    'TRAININGBY': {
      '101': 'Apply manually',
      '102': 'Commissioned',
      '103': 'Curriculum Development Plan',
      '104': 'New employees'
    }
  },
  th: {
    'HRES7FEC1': {
      '10': 'สำหรับปี',
      '20': 'หลักสูตร',
      '30': 'รุ่นที่',
      '40': 'วันที่อบรมตั้งแต่',
      '50': 'ถึง',
      '60': 'รหัสหลักสูตร',
      '70': 'ชื่อหลักสูตร',
      '80': 'รุ่น',
      '90': 'ประเภทการอบรม',
      '100': 'สถานะ',
      '110': 'วันที่ประเมินหลักสูตร'
    },
    'HRES7FEC2': {
      '10': 'สำหรับปี',
      '20': 'หลักสูตร',
      '30': 'รุ่นที่',
      '40': 'แบบฟอร์มการประเมิน',
      '50': 'ข้อมูลอื่นๆ',
      '60': 'ท่านเข้าร่วมการฝึกอบรมโดย',
      '70': 'ท่านได้รับข้อมูลประชาสัมพันธ์หลักสูตรอบรมจากสื่อใด',
      '80': 'ท่านมีความรู้ ความเข้าใจ ก่อนและหลังอบรม มากน้อยเพียงใด',
      '90': 'ก่อนการอบรม',
      '100': 'หลังการอบรม',
      '110': 'แบบประเมิน',
      '120': 'ผลการประเมิน',
      '130': 'ข้อเสนอแนะ',
      '140': 'สรุปข้อมูลที่ได้รับจากการอบรม',
      '150': 'ประโยชน์ที่ได้รับจากการอบรม',
      '160': 'ข้อคิดเห็น / ข้อเสนอแนะ',
      '170': 'น้ำหนัก',
      '180': 'คะแนน',
      '190': 'สถานะการประเมิน',
      '200': 'ระหว่างการประเมิน',
      '210': 'ประเมินเสร็จสิ้น'
    },
    'INFORMTBY': {
      '101': 'Newsletter',
      '102': 'E-mail',
      '103': 'บอร์ดประชาสัมพันธ์',
      '104': 'พนักงานใหม่'
    },
    'TRAININGBY': {
      '101': 'สมัครด้วยตนเอง',
      '102': 'ผู้บังคับบัญชามอบหมาย',
      '103': 'หลักสูตรตามแผนพัฒนาบุคลากร',
      '104': 'พนักงานใหม่'
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/labels/hres7fe.js